export const apptoken = 'pk.eyJ1IjoidHByeWFuIiwiYSI6ImNsaWF1ZmpzbzAyMGUzY3MxbXYwbzJoY2sifQ.y_T2pI-8jbcchYR9V9qB7g'

const north_star = "mapbox://styles/tpryan/cmcfhpwws01zv01r74sq89ebb"
const rdr2 = 'mapbox://styles/tpryan/cmc9ofgil01hi01r70dnx3n7x'
const treasure = 'mapbox://styles/tpryan/cmcfho3gr00u101sraj868zbi'
const wham = 'mapbox://styles/tpryan/cmc0354zm007401sod56l2cfh'
const satilite = 'mapbox://styles/tpryan/cmdv8org8009301src6s000u8'
const mapdefault = 'mapbox://styles/tpryan/cmdv8rr6k009401srd66v4xf7'
const standard = 'mapbox://styles/tpryan/cmdv8ycck007y01reaupw6qcm'
const cali = 'mapbox://styles/tpryan/cmdv92kyp007z01refbb40w2l'
const frank = 'mapbox://styles/tpryan/cmdv985jw009601sr151oem15'

export let mapstyle = rdr2 

